
























































































import { Component, Emit, Prop, Vue } from "vue-property-decorator";

import ListItemWithTooltip from "@/components/common/ListItemWithTooltip.vue";
import MyChat from "@/components/conference/MyChat.vue";
import { MenuItemAction, MenuItem } from "@/interfaces/vuetify/menuItem";
import { ChatEntry } from "@/interfaces/meeting/details";

@Component<NavigationDrawer>({
  components: {
    ListItemWithTooltip,
    MyChat
  }
})
export default class NavigationDrawer extends Vue {
  @Prop({ type: Boolean })
  drawer!: boolean;

  @Prop({ type: Boolean })
  miniVariant!: boolean;

  // START - Chat props
  @Prop({ type: Array })
  chatEntries!: ChatEntry[];

  @Prop({ type: Boolean })
  hasNewMessages!: boolean;

  @Prop()
  userId!: string;

  @Prop()
  userName!: string;
  // END - Chat props

  // Action menu items before the custom slot
  actionMenuItems: MenuItem[] = [];
  // Action menu items after the custom slot
  actionMenuItems2: MenuItem[] = [
    {
      icon: "mdi-pencil",
      text: "Edit name",
      value: MenuItemAction.EDIT_NAME,
      tooltipText: "Edit name"
    },
    {
      icon: "mdi-message",
      text: "Chat",
      value: MenuItemAction.CHAT,
      tooltipText: "Chat"
    }
  ];

  @Emit()
  toggleDrawer() {
    return !this.miniVariant;
  }

  @Emit()
  onEditNameClick() {
    return true;
  }

  @Emit()
  onChatClick() {
    return MenuItemAction.CHAT;
  }

  @Emit()
  sendMessage(message: string) {
    return message;
  }

  @Emit()
  onListItemClick(value: MenuItemAction) {
    return value;
  }
}
